<template>
  <v-footer height="auto">
    <v-container>
        <v-layout wrap class="top">
          <v-flex class="logo">
            <router-link to='/'>
              <img src="../../assets/hgLogo.png" alt="HomeGauge Logo" />
            </router-link>
          </v-flex>
          <v-flex class="main-menu">
              <router-link to='/inspections' class="test-my-inspections">
                MY INSPECTIONS
              </router-link>
              <router-link to='/inspectors'>
                MY INSPECTORS
              </router-link>
              <router-link to='/account' class="test-my-account">
              ACCOUNT
              </router-link>
          </v-flex>
        </v-layout>

        <v-layout wrap class="bottom">
          <v-flex>
            &#xa9; SHGI Corp. 2002 - {{currentYear}}
          </v-flex>

        <v-flex class="external-menu">
          <div>
            <a :href="hgRootUrl + 'buyer/home-buyer/'"  target="_blank">About Us</a>
            <a :href="hgRootUrl + 'contact.html'"  target="_blank">Contact</a>
          </div>
          <div class="second-row">
            <a :href="hgRootUrl + 'hg-terms.html'"  target="_blank">Terms of Use</a>
            <a :href="hgRootUrl + 'privacy.html'"  target="_blank">Privacy</a>
            </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      hgRootUrl: process.env.VUE_APP_HG_CLASSIC,
    };
  },
  computed: {
    currentYear() {
      return new Date().getUTCFullYear();
    },
  },
};
</script>


<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

$_gray-dark: darken($theme-color-gray, 10.98);
$_gray-light: lighten($theme-color-gray, 53.73);

.v-footer {
  background-color: $_gray-dark !important;
  color: $_gray-light !important;

  a {
    color: $_gray-light;
  }
}

.top {
  border-bottom: solid 1px rgba(255, 255, 255, 0.15);
  padding-bottom: 50px;
}

.bottom {
  padding-top: 30px;
}

.main-menu {
  align-self: center;
  display: flex;
  padding-top: 14px;

  a {
    color: $theme-color-white;
    font-size: 1.07rem;
    font-family: $typography-font-secondary;
    font-weight: $typography-weight-bold;
    margin-right: 45px
  }
}

.logo {
  display: flex;
  flex: 0 0 180px;
}

.external-menu {
  display: flex;
  justify-content: flex-end;

  a {
    border-right: solid 1px $_gray-light;
    font-family: $typography-font-secondary;
    font-size: 1.143rem;
    padding-left: 20px;
    padding-right: 20px;
  }
}

.second-row a:last-child {
  border-right: none;
  padding-right: 0;
}

@media all and (max-width: 655px) {
  .logo {
    flex: 1 1 auto;
    justify-content: center;
    margin-bottom: 15px;
  }

  .main-menu {
    align-items: center;
    flex-direction: column;

    a {
      margin-bottom: 20px;
      margin-right: 0;
    }
  }

  .bottom,
  .external-menu,
  .top {
    flex-direction: column;
  }

  .external-menu {
    margin-top: 20px;

    div {
      margin-bottom: 10px;
      text-align: center;

      a:last-child {
        border-right: none;
      }
    }

    a {
      &:first-child {
        border-right: solid 1px $theme-color-white;
        padding-right: 15px;
      }

      &:last-child {
        padding-left: 15px;
      }
    }
  }

  .bottom {
    align-items: center;
  }

  .footer {
    min-height: 440px;
  }
}
</style>
